import script from "./BaseLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseLoader.vue?vue&type=script&lang=ts&setup=true"

import "./BaseLoader.vue?vue&type=style&index=0&id=8d3d7816&lang=scss"

const __exports__ = script;

export default __exports__